import { boolean, object, string } from 'yup';

import {
  MAX_EMAIL_LENGTH,
  MAX_TEXT_FIELD_LENGTH,
  MAX_EXTERNAL_ID_LENGTH,
} from '@/shared/config';

export const sharePatientFormSchema = object({
  email: string().email().required().max(MAX_EMAIL_LENGTH),
  comment: string().optional().max(MAX_TEXT_FIELD_LENGTH).noURL(),
  patientCaseSharingConfirmation: boolean().oneOf([true]).required(),
  patientDataSharingConsentConfirmation: boolean().oneOf([true]).required(),
});

export const addSharedPatientModalSchema = object({
  accessCode: string().required().max(MAX_EXTERNAL_ID_LENGTH),
});
